export const DEFAULT_RESOURCE_CATEGORIES = [
  'Overview',
  'World & Zone maps',
  'World & Zone images',
  'Task icons',
  'Task Content Media',
  'Task Feedback icons',
  'Inventory images',
  'Title images'
];
